export const REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_REQUESTED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_REQUESTED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_SUCCEEDED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_SUCCEEDED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_FAILED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_LOAD_FAILED';

export const REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_SUCCEEDED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_FAILED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_REQUESTED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_CANCELED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_POLLING_CANCELED';

export const REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_REQUESTED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_REQUESTED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_SUCCEEDED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_SUCCEEDED';
export const REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_FAILED =
    'REPORTS_HARVEST_TIMESHEETS_ALL_EXPORT_FAILED';

export const REPORTS_HARVEST_TIMESHEETS_ALL_SET =
    'REPORTS_HARVEST_TIMESHEETS_ALL_SET';
export const REPORTS_HARVEST_TIMESHEETS_ALL_MERGE =
    'REPORTS_HARVEST_TIMESHEETS_ALL_MERGE';
export const REPORTS_HARVEST_TIMESHEET_SET = 'REPORTS_HARVEST_TIMESHEET_SET';
